import { useEffect, useRef } from "react";
import type { CurrentMax } from "@heraion/shared";
import { asyncStorageResourceCache, useMaxesData, type MaxesData } from "@heraion/ui";

import { apiFetch } from "../api";

// #397: the MAXes kept on disk for offline, mobile's key and shape.
const maxesCache = asyncStorageResourceCache<Array<[string, CurrentMax]>>("maxes/current");

// Web has no MaxesContext: each consumer holds its own copy of the MAXes.
// When the bell accepts a MAX (#182), every mounted copy reads again.
const mounted = new Set<() => void>();

/** Every mounted copy re-reads, past its TTL. */
export function notifyMaxWritten(): void {
  for (const refresh of [...mounted]) refresh();
}

/** useMaxesData bound to web's apiFetch, and told when the bell writes a MAX. */
export function useMaxesDataWeb(): MaxesData {
  const data = useMaxesData({ apiFetch, cache: maxesCache });
  const refreshRef = useRef(data.forceRefresh);
  useEffect(() => {
    refreshRef.current = data.forceRefresh;
  });
  useEffect(() => {
    const refresh = () => void refreshRef.current();
    mounted.add(refresh);
    return () => {
      mounted.delete(refresh);
    };
  }, []);
  return data;
}
